import { useState } from 'react'
import { ItemType } from '../../../models/ViewModels/RecordCatalogViewModel'
import {
  AbuseHistoryItem,
  AbuseHistoryType,
} from '../../../models/ViewModels/RecordViewModel'
import { DatePicker, Icon, Select, TextBox } from '../../../share/Elements'
import Card from '../../../share/Components/Card/Card'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'

const RecordAbuseHistory = ({
  abuseItems,
  timeUnits,
  item,
  onItemChange,
}: {
  abuseItems?: Array<ItemType<number>>
  timeUnits?: Array<ItemType<number>>
  item?: AbuseHistoryType
  onItemChange?: (updatedItem: AbuseHistoryType) => void // A function to handle item changes
}) => {
  const [abuse, setAbuse] = useState<AbuseHistoryItem>({
    quitDate: new Date().toDateString(),
    startDate: new Date().toDateString(),
    abuseId: abuseItems![0].id,
    abuseDurationId: timeUnits![0].id,
  })
  function getAbuse(id) {
    const abuseItem = abuseItems?.find((item) => item.id === id)
    return abuseItem ? abuseItem.title : ''
  }
  function getTimeUnit(id) {
    const unit = timeUnits?.find((item) => item.id === id)
    return unit ? unit.title : ''
  }
  const handleAbstractClick = (index: number) => {
    // Handle abstract click logic

    const updatedItems = [...(item?.items || [])]
    updatedItems[index] = {
      ...updatedItems[index],
      showAbstract: !updatedItems[index].showAbstract,
    }

    const data: AbuseHistoryType = {
      ...item,
      items: updatedItems,
    }
    onItemChange && onItemChange(data)
  }

  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item?.items || [])]
    updatedItems.splice(index, 1)

    const updatedObject = { ...item, items: updatedItems }

    onItemChange && onItemChange(updatedObject)
  }
  const handleAddItem = () => {
    const updatedItems = item?.items ? [...item.items] : []
    updatedItems.push(abuse!)

    const updatedDrugItem: AbuseHistoryType = {
      ...item,
      items: updatedItems,
    }
    onItemChange && onItemChange(updatedDrugItem)
    setAbuse({
      ...abuse,
      quitDate: new Date().toDateString(),
      startDate: new Date().toDateString(),
    })
  }
  const handleAmountOfAbuseChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setAbuse({ ...abuse, amountOfAbuse: Number(event.target.value) })
  }
  const handleAbuseDurationChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setAbuse({ ...abuse, abuseDuration: Number(event.target.value) })
  }
  return (
    <>
      <div className='p-6 '>
        <div className='mt-4 grid grid-cols-1/3 2/3 gap-1'>
          <div className='col-span-1'>
            {' '}
            <Select
              className='w-full h-9'
              onChange={(e) => {
                if (e.target.value && e.target.value !== '') {
                  setAbuse({
                    ...abuse,
                    abuseId: Number(e.target.value),
                  })
                }
              }}
              value={getAbuse(abuse?.abuseId!)}
            >
              {abuseItems?.map((n, i) => (
                <option key={i} value={n.id}>
                  {n.title}
                </option>
              ))}
            </Select>
          </div>
          <div className='col-span-2 grid xs:grid-cols-2 grid-cols-5 gap-1'>
            {' '}
            <DatePicker
              innerText='تاریخ'
              isRequired={false}
              className=''
              name='startDate'
              id='startDate'
              raytebValue={abuse?.startDate}
              value={
                abuse?.startDate ? new Date(abuse.startDate).toShamsi() : ''
              }
              onChange={(e) => {
                const fromDateInput = document.getElementById('startDate') // Assuming you have an element with id "toDate"
                const raytebValue = fromDateInput?.getAttribute('rayteb-value')
                const updatedItem: AbuseHistoryItem = {
                  ...abuse,
                  startDate: raytebValue!,
                }
                setAbuse(updatedItem)
              }}
            />
            <DatePicker
              innerText='تاریخ'
              isRequired={false}
              className=''
              name='quitDate'
              id='quitDate'
              raytebValue={abuse?.quitDate}
              value={abuse?.quitDate ? new Date(abuse.quitDate).toShamsi() : ''}
              onChange={(e) => {
                const fromDateInput = document.getElementById('quitDate') // Assuming you have an element with id "toDate"
                const raytebValue = fromDateInput?.getAttribute('rayteb-value')
                const updatedItem: AbuseHistoryItem = {
                  ...abuse,
                  quitDate: raytebValue!,
                }
                setAbuse(updatedItem)
              }}
            />
            <TextBox
              className='w-full h-9'
              RxgMessage=''
              innerText='میزان مصرف'
              debounceTime={0}
              isRequired={false}
              Type={TextBoxTypeEnum.Number}
              value={abuse?.amountOfAbuse?.toString()}
              onChange={handleAmountOfAbuseChange}
            />
            <TextBox
              className='w-full h-9'
              RxgMessage=''
              innerText='مدت زمان'
              isRequired={false}
              debounceTime={0}
              Type={TextBoxTypeEnum.Number}
              value={abuse?.abuseDuration?.toString()}
              onChange={handleAbuseDurationChange}
            />
            <Select
              className='w-full h-9'
              onChange={(e) => {
                if (e.target.value && e.target.value !== '') {
                  setAbuse({
                    ...abuse,
                    abuseDurationId: Number(e.target.value),
                  })
                }
              }}
              value={getTimeUnit(abuse?.abuseDurationId!)}
            >
              {timeUnits?.map((n, i) => (
                <option key={i} value={n.id}>
                  {n.title}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className='mt-4 flex justify-end items-center gap-7'>
          <div className='flex justify-end gap-4 items-center w-full'>
            <Icon
              icon='rayteb-add-circular'
              className='text-xl text-primaryLight'
              onClick={handleAddItem}
            />
          </div>
        </div>
        <div className='mt-5 grid grid-cols-1 gap-1 '>
          {item?.items?.length! > 0
            ? item?.items?.map((n, i) => (
              <Card
                key={i}
                text={getAbuse(n?.abuseId!)}
                footer={
                  <CardFooter
                    item={n}
                    onAbstractClick={() => handleAbstractClick(i)}
                    onDeleteClick={() => handleDeleteClick(i)}
                  />
                }
              >
                <span className='text-[9px] text-primaryLight ml-1  font-bold'>
                  {`میزان مصرف ${n.amountOfAbuse}`}
                  {'-'}
                  {`${n.abuseDuration} ${getTimeUnit(n.abuseDurationId)}`}
                </span>
                <br />
                <span className='text-xs text-primaryLight ml-1 font-bold'>
                  {new Date(n.startDate!).toShamsi()} -
                  {new Date(n.quitDate!).toShamsi()}
                </span>
              </Card>
            ))
            : null}
        </div>
      </div>
    </>
  )
}
const CardFooter = ({
  item,
  onAbstractClick,
  onDeleteClick,
}: {
  item?: AbuseHistoryItem
  onAbstractClick: () => void
  onDeleteClick: () => void
}) => (
  <>
    <div className='w-full flex  justify-between items-center pt-3'>
      <div className='flex justify-center itmes-center gap-2'>
        <Icon
          icon='rayteb-medical-ophthalmology'
          className={`text-xl  ${item?.showAbstract ? 'text-primary' : 'text-disable'
            }`}
          onClick={onAbstractClick}
        />
        <Icon
          icon='rayteb-delete'
          className='text-xl text-primary'
          onClick={onDeleteClick}
        />
      </div>
    </div>
  </>
)
export default RecordAbuseHistory
